import { getRoleColor } from './roles';

interface RolesBadgeListProps {
  roles: string[];
}

/**
 * Affiche une liste de rôles back sous forme de badges colorés.
 * Les rôles connus (cf. `ROLE_COLORS` dans `roles.ts`) ont une couleur
 * dédiée ; les rôles inconnus tombent sur un badge neutre.
 */
export const RolesBadgeList = ({ roles }: RolesBadgeListProps) => {
  if (roles.length === 0) {
    return <span className="text-xs text-zinc-400">—</span>;
  }
  return (
    <span className="inline-flex items-center gap-1 flex-wrap">
      {roles.map(role => {
        const tokens = getRoleColor(role);
        return (
          <span
            key={role}
            className={`inline-flex items-center rounded-md text-[10px] font-medium px-1.5 py-0.5 font-mono tabular-nums ${tokens.bg} ${tokens.text}`}
          >
            {role}
          </span>
        );
      })}
    </span>
  );
};
